<template>
    <div class="event-list-item event-list-item--exhibition event-list-item--search">
        <article class="search-result">
            <div class="event-list-item__text">
                <div class="event-list-item__text-top">
                    <h3 class="heading-3" v-bind:class="{'full-width': !result.badge}" :lang="langCode">
                        <a :href="result.url" target="_blank">
                            {{ result.name }}
                        </a>
                    </h3>
                </div>
                <div v-if="result.badge" class="resource-badge" v-bind:class="{'cmhr-resource': isCMHRresource}">
                    <p class="vertically-challenged-child">{{ result.badge }}</p>
                </div>
                <img class="resource-img" v-if="result.image"
                    :src="result.image"
                    :alt="result.image_alt"/>
                <div class="event-list-item__text__info">
                    <p class="paragraph" v-html="result.description" :lang="langCode"></p>
                </div>
            </div>
            <div class="resource-info">
                <h4 class="visually-hidden">{{i18n_strings.aria_resource_info}} {{result.name}}</h4>
                <div class="metadata">
                    <p v-if="publisher">{{ i18n_strings.source }}: {{ publisher || "—" }}</p>
                    <p v-if="formats">{{ i18n_strings.format }}: {{formats || "—"}} </p>
                </div>
            </div>
            <div class="resource-links">
                <span v-if="result.url">
                    <a :href="result.url" target="_blank">
                        {{viewPrimaryLanguage}} <span class='sr-only'>{{i18n_strings.for}} <span :lang="langCode">{{result.name}}</span></span>
                    </a>
                </span>
                <span v-if="result.url_alt">
                    <a :href="result.url_alt" target="_blank">
                        {{viewSecondaryLanguage}} <span class='sr-only'>{{i18n_strings.for}} <span :lang="langCode">{{result.name}}</span></span>
                    </a>
                </span>
                <a class="no-after metadata" :href="result.absolute_url">
                    {{i18n_strings.metadata}} <span class='sr-only'>{{i18n_strings.for}} <span :lang="langCode">{{result.name}}</span></span>
                </a>
            </div>
        </article>
    </div>
</template>

<style scoped lang="scss">
    .sr-only {
        opacity: 0;
        height: 0;
        width: 0;
        position: absolute;
    }
</style>

<script>
import { mapGetters } from "vuex";

export default {
    name: "SearchResult",
    props: {
        "result": Object
    },
    computed: {
        ...mapGetters([
            'i18n_strings',
            'contentFormats'
        ]),
        publisher: function () {
            if (Object.keys(this.result.publisher).length == 0) {
                return '';
            } else if (this.result.publisher.name) {
                return this.result.publisher.name;
            } else {
                return '';
            }
        },
        formats: function() {
            let resultFormats = this.result.formats;
            let results = this.contentFormats ? this.contentFormats
                            .reduce((formats, next) => {
                                return resultFormats.includes(next['name']) ? formats.concat(next) : formats;
                            }, [])
                            .map(format => format.alternate_name || format.name )
                            .join(", ") : [];
            return results;
        },
        languages: function() {
            return this.result.languages.join(", ");
        },
        langCode: function() {
            if (this.languages.includes(this.i18n_strings.english)) {
                return "en";
            } else if (this.languages.includes(this.i18n_strings.french)) {
                return "fr";
            } else {
                return "en";
            }
        },
        year: function() {
            return this.result.date_created ? this.result.date_created.substring(0,4) : '';
        },
        isCMHRresource: function() {
            return this.result.badge.includes('CMHR') || this.result.badge.includes('MCDP');
        },
        viewPrimaryLanguage: function() {
            let lang = this.langCode == 'en' ? 'english' : 'french';
            return this.i18n_strings[`${lang}_resource`];
        },
        viewSecondaryLanguage: function() {
            let lang = this.langCode == 'en' ? 'french' : 'english';
            return this.i18n_strings[`${lang}_resource`];
        },
    }
};
</script>
